
<language-string-tag-selection [parseObj]="parseObj" [name]="name + 'Tag'" (onValueChange)="onTagSelectionChange($event)"></language-string-tag-selection>
<div class="col-xs-12 mt-3 p-0">
  <language-string-selection [parseObj]="parseObj" [name]="name" [tags]="tags" [required]="required"></language-string-selection>
</div>